/* Redux */
import { useSelector, useDispatch } from 'src/redux/hooks'

const Redux = () => {
  
  const dispatch = useDispatch()
  
  const changeFilterPage = (page: number) =>
    dispatch({ type: 'changeFilterPage', payload: page })

  const changeFilterSize = (size: number) =>
    dispatch({ type: 'changeFilterSize', payload: size })
  
  const activeFilters = useSelector(store => store.Filter.activeFilters)
  const activeBrands = useSelector(store => store.Filter.activeBrands)

  return { 
    changeFilterPage, changeFilterSize,
    activeFilters,
    activeBrands,
  }
}

export default Redux
